export enum CommStatus {
  AwaitingSending = 0,
  Delivered = 1,
  Read = 2,
  Responded = 3,
  Busy = 4,
  NoAnswer = 5,
  BadNumber = 6,
  Send = 7,
  Error = 8,
  BlockedBySpamProtector = 9,
  SendNow = 10,
  Dropped = 11,
  Bounce = 12,
  SpamReport = 13,
  NotActual = 14,
  MultipleAppointments = 15,
  Confirmed = 16,
  AskedForCallback = 17,
  CheckPhoneNumber = 18,
  LeftMessage = 19,
  CheckCallerId = 20,
  SmsTooLong = 21,
  IncomprehensibleAnswer = 22,
  WebhookProcessError = 23,
  LetterTooLong = 24,
  Scheduled = 30,
  ScheduledAwaitingConfirmation = 31,
  ReceivedAnswer = 44,
  RecoverableError = 100,
  CancelledDueToInactivePractice = 111,
  CancelledBySettings = 112,
  Expired = 115,
  InProcess = 254,
  OverBudgetLimit = 255
}